/* V3 click-to-enlarge for the dense diagram images (the 47-sections chart, the
   kit flatlays). Those images carry a lot of small type; on a phone they are
   unreadable at page width and there was no way to open them larger.

   Adds a caption hint, opens a full-screen overlay on click, closes on click,
   Escape or the button. Keyboard reachable, focus returned to the image. */
(function () {
  'use strict';
  var SEL = '.ckm-secimg img, .ckm-hero img, [data-v3-zoom] img, img[data-v3-zoom]';
  var overlay = null, lastFocus = null;

  function close() {
    if (!overlay) return;
    overlay.remove(); overlay = null;
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function open(img) {
    close();
    lastFocus = img;
    overlay = document.createElement('div');
    overlay.className = 'v3-zoom';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', img.alt || 'Enlarged image');
    var big = document.createElement('img');
    big.src = img.currentSrc || img.src;
    big.alt = img.alt || '';
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'v3-zoom__close'; btn.setAttribute('aria-label', 'Close'); btn.innerHTML = '&times;';
    overlay.appendChild(big); overlay.appendChild(btn);
    document.body.appendChild(overlay);
    document.documentElement.style.overflow = 'hidden';
    btn.focus();
    overlay.addEventListener('click', close);
    btn.addEventListener('click', close);
  }

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  function arm() {
    document.querySelectorAll(SEL).forEach(function (img) {
      if (img.dataset.v3ZoomReady) return;
      img.dataset.v3ZoomReady = '1';
      img.classList.add('v3-zoomable');
      img.setAttribute('tabindex', '0');
      img.setAttribute('role', 'button');
      img.setAttribute('aria-label', (img.alt || 'Image') + ' — click to enlarge');
      img.addEventListener('click', function () { open(img); });
      img.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(img); } });
      var fig = img.closest('figure');
      if (fig && !fig.querySelector('.v3-zoom-hint')) {
        var hint = document.createElement('p');
        hint.className = 'v3-zoom-hint';
        hint.textContent = 'Tap to enlarge';
        fig.appendChild(hint);
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm);
  else arm();
  setTimeout(arm, 1500);
})();
